"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledHeroEventUpdateDto = void 0;
const class_validator_1 = require("class-validator");
// none of this gets mapped to the entity so not extending MappableBase
class ScheduledHeroEventUpdateDto {
    constructor(options) {
        if (options)
            Object.assign(this, options);
    }
    start;
    end;
    addStudentId;
    removeStudentScheduledHeroEventId;
    checkInStudentScheduleHeroEventIds;
    checkOutStudentScheduleHeroEventId;
}
exports.ScheduledHeroEventUpdateDto = ScheduledHeroEventUpdateDto;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], ScheduledHeroEventUpdateDto.prototype, "start", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], ScheduledHeroEventUpdateDto.prototype, "end", void 0);
__decorate([
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], ScheduledHeroEventUpdateDto.prototype, "addStudentId", void 0);
__decorate([
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], ScheduledHeroEventUpdateDto.prototype, "removeStudentScheduledHeroEventId", void 0);
__decorate([
    (0, class_validator_1.IsPositive)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], ScheduledHeroEventUpdateDto.prototype, "checkInStudentScheduleHeroEventIds", void 0);
__decorate([
    (0, class_validator_1.IsPositive)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], ScheduledHeroEventUpdateDto.prototype, "checkOutStudentScheduleHeroEventId", void 0);
